import i18n from "../../i18n/index";
import copaymentService from "../../services/copayment/CopaymentService";
import orderService from "../../services/orders/OrderService.js";
import dayjs from "dayjs";
import XLSX from 'xlsx';

export default {
    components: {},
    data: () => ({
        headers: [{
                text: i18n.t('headers.plu'),
                sortable: true,
                value: 'plu'
            },
            {
                text: i18n.t('headers.internal-code'),
                sortable: true,
                value: 'internalCode'
            },
            {
                text: i18n.t('headers.description'),
                sortable: true,
                value: 'description'
            },
            {
                text: i18n.t('headers.groupA'),
                sortable: false,
                value: 'groupA'
            },
            {
                text: i18n.t('headers.groupB'),
                sortable: false,
                value: 'groupB'
            },
            {
                text: i18n.t('headers.groupC'),
                sortable: false,
                value: 'groupC'
            }
        ],
        providers: [],
        provider: {
            id: '',
            name: '',
            fiscalNumber: '',
            active: ''
        },
        copayments: [],
        searchTerm: '',
        file: '',
        selectedProviderId: '',
        loaded: false,
        templateLink: 'http://104.248.183.112:3001/template/copayment',
        loading: false,


        orderNumber: '',
        searchButtonLoading: false,
        loadedOrder: false,
        headers1: [
            { text: 'Pedido', value: 'id', sortable: false },
            { text: 'Estado', value: 'status', sortable: false }
        ],
        headers2: [
            { text: 'Subpedido', value: 'id', sortable: false },
            { text: 'Prestador', sortable: false },
            { text: 'Autorización', sortable: false },
            { text: 'Estado', value: 'status', sortable: false },
            { text: 'Actualizar', sortable: false },
            { text: 'Nuevo estado', sortable: false },
            { text: 'Motivo de cancelación', sortable: false },
            { text: 'Fecha de entrega', sortable: false }
        ],
        avaliableStatuses: {
            'SCHEDULED': [{
                    value: 'CANCELED',
                    text: 'CANCELADO'
                },
                {
                    value: 'DELIVERED',
                    text: 'ENTREGADO'
                },
                {
                    value: 'RETURNED',
                    text: 'DEVUELTO'
                }
            ],
            'CANCELED': [{
                value: 'SCHEDULED',
                text: 'AGENDADO'
            }, ],
            'CHECKED_IN': [{
                    value: 'CANCELED',
                    text: 'CANCELADO'
                },
                {
                    value: 'SCHEDULED',
                    text: 'AGENDADO'
                },
                {
                    value: 'DELIVERED',
                    text: 'ENTREGADO'
                },
                {
                    value: 'RETURNED',
                    text: 'DEVUELTO'
                }
            ],
            'CHECKED_OUT': [{
                    value: 'CANCELED',
                    text: 'CANCELADO'
                },
                {
                    value: 'SCHEDULED',
                    text: 'AGENDADO'
                },
                {
                    value: 'CHECKED_IN',
                    text: 'EMPACADO'
                },
                {
                    value: 'DELIVERED',
                    text: 'ENTREGADO'
                },
                {
                    value: 'RETURNED',
                    text: 'DEVUELTO'
                }
            ],
            'PARTIALLY_CHECKED_IN': [{
                    value: 'CANCELED',
                    text: 'CANCELADO'
                },
                {
                    value: 'SCHEDULED',
                    text: 'AGENDADO'
                },
                {
                    value: 'CHECKED_IN',
                    text: 'EMPACADO'
                },
                {
                    value: 'DELIVERED',
                    text: 'ENTREGADO'
                },
                {
                    value: 'RETURNED',
                    text: 'DEVUELTO'
                }
            ],
            'DELIVERED': [{
                    value: 'CANCELED',
                    text: 'CANCELADO'
                },
                {
                    value: 'SCHEDULED',
                    text: 'AGENDADO'
                },
                {
                    value: 'RETURNED',
                    text: 'DEVUELTO'
                }
            ],
            'RETURNED': [{
                    value: 'CANCELED',
                    text: 'CANCELADO'
                },
                {
                    value: 'SCHEDULED',
                    text: 'AGENDADO'
                },
                {
                    value: 'DELIVERED',
                    text: 'ENTREGADO'
                }
            ]
        },
        maxDatePreviewDelivery: '',
        orderDetails: '',
        updating: false
    }),
    async created() {
        this.maxDatePreviewDelivery = dayjs(new Date()).format("YYYY-MM-DD")
        await this.getCancelReasons()
    },

    computed: {},

    watch: {},

    methods: {
        async getCancelReasons() {
            try {
                const response = await orderService.getTypeAuthorizationOrder()
                this.cancelReasons = response.data
            } catch (error) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Error obteniendo los motivos de cancelación'
                })
            }
        },
        async searchOrder() {
            try {
                this.searchButtonLoading = true
                let response = await orderService.getOrderWithMedicines(this.orderNumber)
                if (response.data === 'No order') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'No existe el pedido'
                    })
                } else {
                    this.order = response.data
                        // this.order.update = false
                        // this.order.newStatus = ''
                    this.order.orderDetails.forEach(od => {
                        od.update = false
                        od.newStatus = ''
                        od.cancelReason = ''
                        od.previewDeliveryDate = ''
                        od.menu = false
                    })
                    this.orderDetails = JSON.parse(JSON.stringify(this.order.orderDetails))
                    this.loadedOrder = true
                }
                this.searchButtonLoading = false
            } catch (error) {
                this.searchButtonLoading = false
            }
        },
        changeCheckBox(item) {
            this.$forceUpdate();
        },
        changeCancelReason(item) {
            this.$forceUpdate();
        },
        onChangeFileUpload() {
            if (this.$refs.file.files[0] !== undefined) {
                this.file = this.$refs.file.files[0]
                this.loaded = true
            } else {
                this.loaded = false
            }
        },
        downloadTemplate() {
            const columns = XLSX.utils.json_to_sheet([{ pedido: 1, estado: 'entregado' }, { pedido: 2, estado: 'entregado' }, { pedido: 3, estado: 'devuelto' }])
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, columns, 'pedidos')
            XLSX.writeFile(wb, 'plantilla_cambio_masivo_estado.xlsx')
        },
        async updateOrder() {
            try {
                this.updating = true
                const data = {
                        order: this.order,
                        orderDetails: this.orderDetails
                    }
                    //TODO: modified
                    // let response = await orderService.updateOrderStatus(data)
                let response = await orderService.updateOrderStatusModified(data)
                this.updating = false
                await this.searchOrder()
                this.$notify({
                    group: 'app',
                    type: 'success',
                    text: 'Pedido actualizado con éxito'
                })
            } catch (error) {
                this.updating = false
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Error en cambio de estados'
                })
            }
        },
        async readFile() {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    let data = e.target.result;
                    data = new Uint8Array(data);
                    let workbook = XLSX.read(data, { type: 'array' });
                    let result = {};
                    let i = 0;
                    workbook.SheetNames.forEach(function(sheetName) {
                        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                        if (roa.length) {
                            result[i] = roa;
                            i++;
                        }
                    });
                    resolve(result);
                };
                reader.onerror = function(event) {
                    reader.abort();
                    reject(reader.error)
                };
                reader.readAsArrayBuffer(this.file);
            });
        },
        async submitForm() {
            try {
                if (this.file !== undefined && this.file !== '') {
                    this.loading = true

                    const dataFromExcel = await this.readFile();

                    if (dataFromExcel[0].length === 0) {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: 'El archivo no contiene información'
                        })
                        return
                    }

                    for (let i = 0; i < dataFromExcel[0].length; i++) {
                        const row = dataFromExcel[0][i];
                        if (!row.hasOwnProperty('pedido')) {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: `El archivo no contiene un número de pedido en la línea ${i + 1}`
                            })
                            return
                        }
                        if (!row.hasOwnProperty('estado')) {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: `El archivo no contiene el nuevo estado del pedido en la línea ${i + 1}`
                            })
                            return
                        }
                        if (!/^\d+$/.test(row.pedido)) {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: `El archivo no contiene un número de pedido válido en la línea ${i + 1}`
                            })
                            return
                        }

                        if (row.estado !== 'entregado' && row.estado !== 'devuelto' && row.estado !== 'cancelado') {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: `El archivo no tiene un estado válido en la línea ${i + 1}`
                            })
                            return
                        }
                    }
                    const data = {
                        data: dataFromExcel[0]
                    }
                    let response = await orderService.bulkUpdate(data)
                    this.$notify({
                        group: 'app',
                        type: 'success',
                        text: 'Cambios de estado realziados con éxito'
                    })
                    this.loading = false
                } else {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'No ha cargado el archivo de cambios de estado'
                    })
                }
            } catch (error) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: error
                })
            }
        }
    }
}